import { call, take, put }          from 'redux-saga/effects';
import axios                        from 'axios';
import { 
         SET_CONTENT,
         UPDATE_TOTAL_LIKES,
         UPDATE_ACTIVITY,
         RECORD_ERROR_SAGA
       }                            from 'actions';

import { organize_format }          from 'functions/rectify_data/set_teacher_content';
import { make_hash }                from 'functions/set_data/make_hash';
import { make_all_content_arr }     from 'functions/set_data/make_all_content_arr';


import mockMivdakim                 from 'content/mockContent/mivdakim';
import mockTeacherLessons           from 'content/mockContent/teacherLessons';


//const endpoint            = `https://www.yisumatica.org.il/flash-upload/js/outsiders/php/get_kehila_list.php`;
const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/getKehilaLessons.php';



function* getTeacherContent(): Generator<any,any,any> {
  while(true) {
    try {

      const userInput     = yield take('GET_TEACHER_CONTENT_SAGA');
      const { userIsZvi } = userInput.payload;

      if ( process.env.NODE_ENV === 'development' ) {

        console.log('GET_TEACHER_CONTENT_SAGA')
                
        const mockMivdakim_:       { [key: string]: any }[] = yield organize_format('mivdakim', mockMivdakim);
        const mockTeacherLessons_: { [key: string]: any }[] = yield organize_format('teacherLessons', mockTeacherLessons);

        const bigTeacherArr: { [key: string]: any }[] = mockTeacherLessons_.concat(mockMivdakim_)

        const allContent =  make_all_content_arr('teacherContet', bigTeacherArr)

        const hash: { [key: string]: any } = yield make_hash(allContent);

        const payload = {
              allContent:            allContent,
              teacherLessons:        mockTeacherLessons_,
              hash:                  hash,
              mivdakim:              mockMivdakim_,
              bigTeacherArr:         bigTeacherArr,
              teacherContentUpdated: true,
              storageContentUpdated: true,
              sender:                'getTeacherContent'
          }
        

        yield put(SET_CONTENT( payload ))

      }


      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   


      if (process.env.NODE_ENV === 'production') {

                // send request to DB
  
                    const  Tlessons    = yield call( axios.post, endpoint, { kehila: 1, showUnaproved: userIsZvi } );
                    const  mivdakim    = yield call( axios.post, endpoint, { kehila: 2, showUnaproved: userIsZvi } );

                    const responseMivdakim = !!mivdakim && !!mivdakim.data && !!mivdakim.data.result ? mivdakim.data.result : [];
                    const responseTlessons = !!Tlessons && !!Tlessons.data && !!Tlessons.data.result ? Tlessons.data.result : [];

                    const mivdakim_: { [key: string]: any }[] = !!responseMivdakim.length ? yield organize_format('mivdakim', responseMivdakim) : [];
                    const Tlessons_: { [key: string]: any }[] = !!responseTlessons.length ? yield organize_format('teacherLessons', responseTlessons) : [];

                    const bigTeacherArr: { [key: string]: any }[] = Tlessons_.concat(mivdakim_).filter((val) => { return(!(val.youtube && val.youtube === 'hide')) });

                    const allContent =  make_all_content_arr('teacherContet', bigTeacherArr)
  
                    const hash: { [key: string]: any } = yield make_hash(allContent);
  
                    const payload = {
                        allContent:            allContent,
                        hash:                  hash,
                        teacherLessons:        Tlessons_,
                        mivdakim:              mivdakim_,
                        bigTeacherArr:         bigTeacherArr,
                        teacherContentUpdated: true,
                        storageContentUpdated: true,
                        sender:                'getTeacherContent'
                    }

                //    console.log('puzzlesFinal : ',JSON.stringify(puzzlesFinal, null, 2))
                    
                    yield put(SET_CONTENT( payload ))
                    yield put(UPDATE_TOTAL_LIKES())
                    yield put(UPDATE_ACTIVITY())
          
                

        }
      
      

    }
    catch(err) {
      yield put(RECORD_ERROR_SAGA({ data: { error: err }, endpoint: 'get teacher content saga' }))
      console.log('err at get teacher content saga  :  '+err);

    }
    finally {}
  }
}


export default getTeacherContent;
